// extracted by mini-css-extract-plugin
module.exports = {"container":"project_container__2WuCZ","description":"project_description__1rmqh","hover":"project_hover__rjrbY","taskDescriptions":"project_taskDescriptions__3O6vs"};